// extracted by mini-css-extract-plugin
module.exports = {"ImageBox":"Image_ImageBox__ZWCOm","Image":"Image_Image__gU4un","ImageInfo":"Image_ImageInfo__Kn4vB"};